import React from 'react';
import { useTranslation } from 'react-i18next';

import { ModalAction } from "components/commons/Modals";
import { Button } from 'components/commons';

interface IYoutubeVideoCard {
    Icon: React.FC<{fill: string}>,
    title: string,
    description: string,
    buttonText?: string,
}

const YoutubeVideoCard: React.FC<IYoutubeVideoCard> = ({
    Icon,
    title,
    description,
    buttonText = "Send Callback",
}) => {
  const [modalOpen, setModalOpen] = React.useState(false);

  const { t } = useTranslation();

  const setModalOpenHandler = (e: React.MouseEvent) => {
      e.stopPropagation();
      setModalOpen(true)
  }

  return (
    <>
      <div 
        className="cursor-pointer bg-white shadow-lg rounded-sm border border-gray-200 hover:border-gray-300 shadow-sm transition-all"
        onClick={setModalOpenHandler}
        >
        <div className="flex flex-col h-full p-5">
          <div className="flex-grow">
            <header className="flex items-center mb-4">
              <div 
                className={`w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0 mr-3`}
              >
                <Icon fill="#1F55A1" />
              </div>
              <h3 className="text-base text-gray-800 text-left font-semibold">
                {t(title, { ns: 'messages' })}
              </h3>
            </header>
            <div className="text-sm text-left w-10/12 text-black">{t(description)}</div>
          </div>
          <footer className="mt-4">
            <div className="flex flex-wrap justify-between items-center">
              <button className="btn-sm border-gray-200 hover:border-gray-300 shadow-sm flex items-center">
                <span className="text-[#1f55a1]">
                  {t(buttonText, { ns: 'messages' })}
                </span>
              </button>
            </div>
          </footer>
        </div>
      </div>
      <ModalAction
        description={t(description)}
        image={<Icon fill="#1F55A1" />}
        id="youtubeVideoCard"
        modalOpen={modalOpen} 
        setModalOpen={setModalOpen} 
        title={t(title)}
        customSize={'max-w-[1000px]'}
      >
          <div>
              <video className={`my-3`} src="https://lk.market/uploads/nalog.mp4" poster="https://lk.market/uploads/nalog.png" width={952} controls={true}></video>
              {/* Modal footer */}
              <div className="px-5 py-4 border-t border-gray-200">
                  <div className="flex flex-wrap justify-end space-x-2 mt-4">
                      <Button
                          type="button"
                          appearance="tertiary"
                          clickHandler={() => setModalOpen(false)}
                          customClassName="btn-sm"
                      >
                          {t("Close", { ns: "messages" })}
                      </Button>
                  </div>
              </div>
          </div>

      </ModalAction>
    </>
  );
}

export default YoutubeVideoCard;
